export const replace = (exp: string | RegExp, repl: any) => (data: any) => data.replace(exp, repl);
export const join = (char: string) => (parts: string[]) => parts.join(char);
export const split = (on: string) => (str: string) => str.split(on);
